
import {defineComponent, PropType, ref, watch} from "vue";
import ValidationFormErrors from "@/Components/Forms/ValidationFormErrors.vue";
import HcButton from "@/Components/Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import Card from "@/Components/General/Card.vue";
import Modal from "@/Components/General/Modal.vue";
import {mdiContentSave, mdiLoading, mdiTrashCan} from "@mdi/js";
import { useForm } from "@inertiajs/inertia-vue3";
// @ts-ignore
import CategorySelect from "@/Components/FAQCategories/CategorySelect.vue";
// @ts-ignore
import {Option} from "@/types/LevelsSelectTypes";
import FaqCategory from "@/types/FaqCategory";
import {Inertia} from "@inertiajs/inertia";
import route from "ziggy-js";



interface CategoryForm {
  title: string;
  parent_id: number | null;
}

export default defineComponent({
  props: {
    category: Object as PropType<Option>,
    categories: Object as PropType<Option[]>,
  },
  emits: ["cancel", "deleted"],
  components: {
    CategorySelect,
    ValidationFormErrors,
    HcButton,
    SvgIcon,
    Card,
    Modal,
  },

  setup(props:any, {emit}) {
    const category = ref<FaqCategory|null>(props.category);
    const showDeleteModal = ref(false);
    const form = ref(
      useForm<CategoryForm>({
        title: category.value?.title ? category.value?.title : "",
        parent_id: category.value?.parent_id ? Number(category.value?.parent_id) : null,
      })
    );

    function resetForm() {
      form.value.reset();
      form.value.clearErrors();
      form.value.title = category.value?.title ?? "";
      form.value.parent_id = category.value?.parent_id ? Number(category.value?.parent_id) : null;
    }

    watch(showDeleteModal, function () {
      resetForm();
    });

    watch(
      () => category.value?.id,
      function () {
        form.value = useForm<CategoryForm>({
          title: category.value?.title ? category.value?.title : "",
          parent_id: category.value?.parent_id ? Number(category.value?.parent_id) : null,
        });
      }
    );
    const selectOption = (event: any, option: Option) => {
      if (Array.isArray(event)) {
        if (!option) {
          option = event[1];
        }
        event = event[0]

      }

      event.stopPropagation()
      if (option?.id !== form.value.parent_id) {
        form.value.parent_id = option?.id as any;
      } else {
        form.value.parent_id = null
      }

    };


    function submit() {
      if (category.value) {
        form.value.patch(
          route("faq-categories.update", {
            faq_category: category.value.id,
          }),
          {
            onSuccess: (page:any) => {
              category.value = page.props.selectedCategory
              resetForm();
            },
          }
        );
      } else {
        form.value.post(route("faq-categories.store"), {
          onSuccess: () => {
            resetForm();
          },
        });
      }
    }

    function cancelCreate() {
      resetForm();
      emit("cancel");
    }

    function deleteCategory() {

      if (!category?.value?.id) {
        return;
      }
      Inertia.delete(
        route("faq-categories.destroy", {
          faq_category: category.value.id,
        }),
        {
          only:["categories"],
          onSuccess: () => {
            showDeleteModal.value = false;

            emit("deleted");
          },
        }
      );
    }

    return {
      saveIcon: mdiContentSave,
      loadingIcon: mdiLoading,
      deleteIcon: mdiTrashCan,
      form,
      showDeleteModal,
      submit,
      cancelCreate,
      deleteCategory,
      selectOption
    };
  },
});
